import { render, staticRenderFns } from "./LentiSole.vue?vue&type=template&id=10920b22&scoped=true"
import script from "./LentiSole.vue?vue&type=script&lang=ts"
export * from "./LentiSole.vue?vue&type=script&lang=ts"
import style0 from "./LentiSole.vue?vue&type=style&index=0&id=10920b22&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10920b22",
  null
  
)

export default component.exports